// extracted by mini-css-extract-plugin
export var link = "_r2-0";